import { render } from "./FavoriteProduct.vue?vue&type=template&id=1881b483"
import script from "./FavoriteProduct.vue?vue&type=script&lang=js"
export * from "./FavoriteProduct.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__